import type { QrCode } from "@repo/api";
import { useEffect, useState } from "react";

import { Button } from "~/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "~/components/ui/dialog";
import QRForm from "./qr-form";

export default function QRDialog({
  qrCode,
  onClose,
  open,
}: {
  onClose: () => void;
  open: boolean;
  qrCode?: QrCode;
}) {
  const [localOpen, setLocalOpen] = useState(open);

  const handleDialog = (open: boolean) => {
    if (open === false) {
      onClose();
    }
    setLocalOpen(open);
  };

  useEffect(() => {
    setLocalOpen(open);
  }, [open]);

  return (
    <Dialog open={localOpen} onOpenChange={handleDialog}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>QR CODE</DialogTitle>
        </DialogHeader>
        <div className="overflow-auto max-h-[80vh] small-scrollbar p-4">
          <QRForm
            onClose={() => {
              handleDialog(false);
            }}
            qrCode={qrCode}
          />
        </div>
        <DialogFooter>
          <Button
            className="w-full"
            variant="success"
            type="submit"
            form="qrForm"
          >
            Opslaan
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
